// @owners { team: patients }
import { SHIPMENT_STATUS_MAP } from '~shared/features/shipments/constants';

export const useShipmentStatusMap = () => {
  return SHIPMENT_STATUS_MAP;
};
